import { withAuth } from '@/lib/apiInterceptor';
import { useCallback } from 'react';

/**
 * Custom hook that provides a way to ensure API calls are made only after
 * authentication is fully established, preventing 401 errors
 */
export const useApi = () => {
  /**
   * Makes an API call, but ensures it only executes when auth is ready
   * This prevents 401 errors that can occur during auth initialization
   * 
   * @param apiFn Function that makes an API call
   * @returns Promise that resolves with the result of the API call
   */
  const withAuthGuard = useCallback(<T>(apiFn: () => Promise<T>): Promise<T> => {
    return withAuth(apiFn);
  }, []);

  return {
    withAuthGuard
  };
}; 